module.exports = __webpack_public_path__ + "static/media/1_mobile.1048cd1e.jpg";